
import { formatDate } from '@/utils';
import { Grid } from '@mui/material';
import dayjs from 'dayjs';
import { GraphicsMonitor } from '../templates/graphics';

const DailyReport = ({ showDetail = true }: any) => {
  const lastDate = dayjs(new Date().setDate(new Date().getDate() + 2)).format('YYYY-MM-DD');
  const firstDate = formatDate(dayjs());

  const paramsRequest: Record<string, string | boolean> = { firstDate, lastDate, isOpen: true };

  return (
    <Grid container spacing={3} marginY={1} px={3} mb={6} justifyContent="center">

    <GraphicsMonitor params={paramsRequest} />
    </Grid>
  );
};

export default DailyReport;
